module.exports = (repos) => {
  const result = {};

  for (let repoName of Object.keys(repos)) {
    const topics = repos[repoName].topics;
    for (topic of topics) {
      if (!result.hasOwnProperty(topic)) {
        result[topic] = [];
      }

      result[topic].push(repoName);
    }
  }

  return result;
};


// WEBPACK FOOTER //
// ./src/lib/utils/getSortedTopics.js